import { ChangeEvent, ChangeEventHandler, useCallback } from 'react'
import { LocgValues } from '@dtx-company/app/shared/code/src/machines/locg/locgMachine.types'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'

export const useOnChange = (): ChangeEventHandler => {
  const { locgService } = useGlobalServices()

  return useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      locgService.send({
        type: 'CHANGE',
        key: event.target.name as keyof LocgValues,
        value: event.target.value
      })
    },
    [locgService]
  )
}
